function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 14,
  cy: 14,
  r: 13.5,
  fill: "#EAF1E9",
  stroke: "black"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8 16.1429L10.6667 19L20 9",
  stroke: "black"
});

const SvgSuccess = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 28,
  height: 28,
  viewBox: "0 0 28 28",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSuccess, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/success.cb0c06a6.svg";
export { ForwardRef as ReactComponent };